import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material"
import { useTranslation } from 'react-i18next'
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"

enum Gender {
    Male = `M`,
    Female = `F`,
    Other = `U`,
}

function GenderInputField(props: FormFieldProps<string>) {
    const { t } = useTranslation(`signup`)
    const { handleChange, defaultValue, errorText, isDisabled, myInfoSuccess } = props

    const choices = () => {
        if ((myInfoSuccess && !isDisabled) || (defaultValue === Gender.Other)) {
            return (
                <>
                    <FormControlLabel value="M" control={<Radio />} label={t(`gender.male`) + ``} disabled={isDisabled} />
                    <FormControlLabel value="F" control={<Radio />} label={t(`gender.female`) + ``} disabled={isDisabled} />
                    <FormControlLabel value="U" control={<Radio />} label={t(`gender.other`) + ``} disabled={isDisabled} />
                </>
            )
        }

        return (
            <>
                <FormControlLabel value="M" control={<Radio />} label={t(`gender.male`) + ``} disabled={isDisabled} />
                <FormControlLabel value="F" control={<Radio />} label={t(`gender.female`) + ``} disabled={isDisabled} />
            </>
        )
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        handleChange(event.target.value)
    }

    return (
        <FormControl margin="normal" color="primary" error={errorText !== undefined}>
            <FormLabel id="gender-radio-buttons-group-label">{t(`select_gender`)}</FormLabel>
            <RadioGroup
                row
                aria-labelledby="gender-radio-buttons-group-label"
                defaultValue={defaultValue}
                name="radio-buttons-group"
                onChange={handleOnChange}
                value={defaultValue}
            >
                {
                    choices()
                }
            </RadioGroup>
            <FormHelperText>{errorText ? t(errorText) : ``}</FormHelperText>
        </FormControl>
    )
}

export type { Gender }
export default GenderInputField